import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

export const postAddMessage = (payload) => api.create(url.POST_ADD_MESSAGE, payload);

